import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../components/GroupMember/Header';
import InfoBlock from '../components/GroupMember/InfoBlock';
import cross from '../assets/images/close-circle.png';
import MemberBasicInfo from '../components/GroupMember/MemberBasicInfo';
import OtherGroupDetails from '../components/GroupMember/OtherGroupDetails';
import QuestionAnswer from '../components/GroupMember/QuestionAnswer';
import Loader from '../components/Loader';
import Toaster from '../components/Toaster';
import { getLeadInfo } from '../redux/actions/groupInfo';

const MemberDetails = ({ match }) => {
	const leadInfo = useSelector((state) => state.leadInfo);
	const { loading, lead, otherGroups } = leadInfo;

	const dispatch = useDispatch();

	useEffect(() => {
		if (!lead || !lead._id || lead._id !== match.params.leadid) {
			dispatch(getLeadInfo(match.params.leadid));
		}
	}, [lead, match, dispatch]);

	return (
		<>
			{loading ? (
				<Loader />
			) : (
				lead && (
          <>

          <div className="overlayMain activate"></div>
					<div className="modalDivWraper memberSetails activated"> 
					<div className='innerMainsWrapers'>
          <span className="crossModalSec">
          <Link  to='/'>
							<img src={cross} className='closeModals' alt='closeModalsImage' />{' '}
						</Link>
          </span>
						<Header lead={lead} otherGroups={otherGroups} />
						<div className='mainPageWraper'>
							<InfoBlock lead={lead} />
							<div className='memberOtherInfos'>
								<MemberBasicInfo lead={lead} />
								<QuestionAnswer lead={lead} />
								<OtherGroupDetails otherGroups={otherGroups} />
							</div>
						</div>
						<Toaster />{' '}
						</div>
					</div>
          </>
				)
			)}
		</>
	);
};

export default MemberDetails;
